import { Component, HostListener, OnInit } from '@angular/core';
import { DeviceService } from '../services/device-service/device.service';
import {
  ColDef,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IDatasource,
  IGetRowsParams,
  PaginationChangedEvent,
  SortChangedEvent,
} from 'ag-grid-community';
import {
  AG_GRID_PAGE_SIZE_OPTIONS, AG_GRID_DEFAULT_PAGE_SIZE,
  AG_GRID_EMPTY_BODY_ROW_PX,
  AG_GRID_HEADER_AND_PAGING_PX,
  COMMENT_AUDIT_ROW_HEIGHT_BASE_PX,
  resolveAgGridLayoutRowCount,
  resolveCommentAuditRowHeightPx,
  syncInfiniteRowModelPageSize,
} from '../shared/ag-grid/ag-grid-pagination.util';

import { AgGridAngular } from 'ag-grid-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { get } from 'lodash'; // for copy data cell value
import { CommentCellRendererComponent } from '../comment-cell-renderer/comment-cell-renderer.component';
import { PeripheralsService } from '../services/peripherals-service/peripherals.service';
import { AgGridCopyCellTooltipDirective } from '../shared/ag-grid/ag-grid-copy-cell-tooltip.directive';

@Component({
  selector: 'app-engineering',
  standalone: true,
  imports: [CommonModule,AgGridAngular,MatFormFieldModule,MatSelectModule,MatSelectModule, MatIconModule,
    CommentCellRendererComponent,
    AgGridCopyCellTooltipDirective,
  ],
  templateUrl: './engineering.component.html',
  styleUrl: './engineering.component.scss'
})
export class EngineeringComponent implements OnInit {
  rowData: any;
  gridApi?: GridApi;
  totalElements = 0;
  sortFlag = false;
  deviceId: any;
  paginationPageSize = AG_GRID_DEFAULT_PAGE_SIZE;
  readonly pageSizeOptions = AG_GRID_PAGE_SIZE_OPTIONS;
  currentPage = 0;
  /** Host height from actual current-page row heights — page scrolls, not the grid. */
  gridHostHeightPx = AG_GRID_HEADER_AND_PAGING_PX + AG_GRID_EMPTY_BODY_ROW_PX;
  deviceAndPeriIds: number[] = [];

  get gridLayoutRowCount(): number {
    return resolveAgGridLayoutRowCount(this.paginationPageSize, this.totalElements);
  }

constructor(private deviceService:DeviceService, private peripheralService:PeripheralsService){}
ngOnInit(): void {
  const deviceId = localStorage.getItem('deviceId');
  if (deviceId != null && deviceId !== '') {
    this.deviceId = deviceId;
    this.deviceAndPeriIds = [Number(deviceId)];
  }

  this.peripheralService.peripheralIds.subscribe((ids: number[]) => {
    this.mergeDeviceAndPeripheralIds(ids, deviceId);
    this.refreshGrid();
  });
}
 defaultColDef: ColDef = {
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    floatingFilter: false,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Time (UTC)',
      field: 'updateOn',
      sort: 'desc',
      // valueGetter: (params) => params.data?.createdOn || 'N/A',
      cellRenderer: (params: any) => {
        const updateOn = params?.data?.updateOn;
        if (updateOn === undefined) {
          return '';
        } else if (updateOn === null || updateOn === '') {
          return 'N/A';
        } else {
          return moment.utc(params?.data?.updateOn).format('YYYY-MM-DD HH:mm:ss');
          //return moment.utc(updateOn).local().format('YYYY-MM-DD HH:mm:ss')
        }
      },
      // cellRenderer: (params: any) => {
      //   if (params?.data?.updateOn) {
      //     // Convert installationDate to a JavaScript Date object
      //     const date = new Date(params.data.updateOn);

      //     // Format the date using Intl.DateTimeFormat
      //     const formattedDate = new Intl.DateTimeFormat('en-US', {
      //       year: '2-digit',
      //       month: '2-digit',
      //       day: '2-digit',
      //       hour: '2-digit',
      //       minute: '2-digit',
      //       hour12: true,
      //       timeZone: 'America/Los_Angeles', // Adjust for PST
      //     }).format(date);

      //     // Add "PST" to the formatted date
      //     return formattedDate.replace(',', '') + ' PST';
      //   }
      //   return 'NA';
      // },
    },
    {
      headerName: 'Event Type',
      field: 'entityName',
      valueGetter: (params) => params.data?.eventType?.category || 'N/A',
    },

    {
      headerName: 'Status',
      field: 'status',
      valueGetter: (params) => params.data?.eventType?.status || 'N/A',
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      valueGetter: (params) => params.data?.createdBy || 'N/A',
    },
    // {
    //   headerName: 'Comments',
    //   field: 'details',
    //   flex: 1,
    //   cellStyle: { 'white-space': 'normal' , 'word-break': 'break-all', 'overflow': 'visible', 'overflow-wrap': 'break-word'},
    //   wrapText: true,
    //   valueGetter: (params) => params?.data?.details || 'N/A',
    //   tooltipValueGetter: (params) => params?.data?.details
    // },
    {
      headerName: 'Comments',
      field: 'details',
      flex: 1,
      cellRenderer: CommentCellRendererComponent,
      tooltipValueGetter: (params) => params?.data?.details,
      cellStyle: {
        'white-space': 'normal',
        'word-break': 'break-word',
        'overflow-wrap': 'break-word'
      }
    }
  ];
  public gridOptions: GridOptions = {
    domLayout: 'normal',
    enableBrowserTooltips: true,
    tooltipShowDelay: 500,
    tooltipHideDelay: 1000,
    suppressRowTransform: true,
    rowHeight: COMMENT_AUDIT_ROW_HEIGHT_BASE_PX,
    getRowHeight: (params) =>
      resolveCommentAuditRowHeightPx(params?.data?.details),
  };
  deviceHistoryPayload = {
    page: 0,
    size: AG_GRID_DEFAULT_PAGE_SIZE,
    filters: [
      {
        field: 'entityId',
        operator: 'in',
        value: [] as number[],
      },
      {
        field: 'eventType.id',
        operator: 'ne',
        value: '11',
      },
      {
        field: 'eventType.id',
        operator: 'ne',
        value: '12',
      },
    ],
    sorts: [
      {
        field: 'updateOn',
        direction: 'desc',
      },
    ],
  };

  readonly dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      this.sortForAgGrid(params.sortModel);
      this.syncEntityIdFilter();

      this.deviceHistoryPayload.page = Math.floor(
        params.startRow / this.paginationPageSize
      );
      this.deviceHistoryPayload.size = this.paginationPageSize;

      this.deviceService.getDeviceAuditEngineering(this.deviceHistoryPayload).subscribe({
        next: (data: any) => {
          const rows = Array.isArray(data?.data?.content) ? data.data.content : [];
          const total = Number(data?.data?.totalElements ?? 0);
          this.rowData = rows;
          this.totalElements = total;
          this.syncGridHostHeight(rows);
          params.successCallback(rows, total);

          if (rows.length > 0) {
            const currentPageData = rows.reduce((acc: Record<string, unknown>, item: { id: string | number }) => {
              acc[item.id] = item;
              return acc;
            }, {} as Record<string, unknown>);
            this.deviceService.fetchCurrentPageData = {
              ...this.deviceService.fetchCurrentPageData,
              ...currentPageData,
            };
          }
        },
        error: (error) => {
          console.error('API Error:', error);
          this.syncGridHostHeight([]);
          params.failCallback();
        },
      });
    },
  };

  onPaginationChanged(event: PaginationChangedEvent): void {
    const pageSizeChanged = syncInfiniteRowModelPageSize(
      event,
      this.paginationPageSize,
      (newPageSize) => {
        this.paginationPageSize = newPageSize;
        this.deviceHistoryPayload.size = newPageSize;
        this.deviceHistoryPayload.page = 0;
      }
    );
    if (pageSizeChanged) {
      event.api.paginationGoToFirstPage();
      event.api.purgeInfiniteCache();
    }
    this.currentPage = event.api.paginationGetCurrentPage();
  }

  onSortChanged(_event: SortChangedEvent): void {
    this.deviceHistoryPayload.page = 0;
    this.refreshGrid();
  }

  sortForAgGrid(sortModel: any) {
    if ( sortModel[0] == undefined ||sortModel[0] == null ||sortModel[0].colId == undefined ||sortModel[0].colId == null) {
      return;
    }
    this.sortFlag = true;
    switch (sortModel[0].colId) {
      case 'entityName': {
        this.deviceHistoryPayload.sorts[0].field = 'eventType.category';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'updateOn': {
        this.deviceHistoryPayload.sorts[0].field = 'updateOn';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'status': {
        this.deviceHistoryPayload.sorts[0].field = 'eventType.status';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'createdBy': {
        this.deviceHistoryPayload.sorts[0].field = 'createdBy';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'details': {
        this.deviceHistoryPayload.sorts[0].field = 'details';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      default: {
      }
    }
  };

  /* Start Copy Data cell Value function   */
  contextMenu: { visible: boolean; x: number; y: number; value: any } = {
    visible: false,
    x: 0,
    y: 0,
    value: ''
  };
  selectedCellValue: string = '';
  contextMenuVisible: boolean = false;
  contextMenuPosition = { x: 0, y: 0 };

  getNestedProperty(obj: any, path: string): any {
    return get(obj, path, 'N/A'); // 'N/A' if value is undefined
  }


  onCellContextMenu(event: any) {
    event.event.preventDefault(); // Prevent the browser's default context menu

    let cellValue;
    const columnField = event.colDef.field;

    if (columnField === 'updateOn') {
      const updateOn = event?.data?.updateOn;
      if (updateOn === undefined) {
        cellValue = '';
      } else if (updateOn === null || updateOn === '') {
        cellValue = 'N/A';
      } else {
        cellValue = moment.utc(updateOn).format('YYYY-MM-DD HH:mm:ss');
      }
    } else if (columnField === 'details') {
      // issue#2398 start
      const valueText = event?.data?.details ?? 'N/A';
      // Description: Base text of the comments cell; includes original details string
      const name = event?.data?.eventType?.name?.toLowerCase();
      // Description: Normalize event type name to derive peripheral action wording
      const status = event?.data?.eventType?.status;
      // Description: Status used to include peripherals only for Success/In Progress
      const id = event?.data?.id;
      // Description: Row id used to look up current page cache if peripherals are missing on data
      const peripherals = event?.data?.peripherals ?? this.deviceService.fetchCurrentPageData[id]?.peripherals ?? null;
      // Description: Prefer row's peripherals; fallback to cached page data for consistency
      let lines: string[] = [];
      // Description: Aggregate human-readable lines for each peripheral to append to copy text
      if (
        peripherals &&
        (status === 'Success' || status === 'In Progress') &&
        (name === 'installed' || name === 'installing' || name === 'deleted' || name === 'updated')
      ) {
        // Description: Only build lines when peripherals exist and event context is relevant
        for (const item of peripherals) {
          // Description: Iterate peripherals to construct descriptive statements
          const make = item?.product?.make || '';
          // Description: Peripheral make used for clearer identification
          const mac = item?.macAddress || '';
          // Description: MAC address to identify the specific peripheral
          const loc = item?.locationName || '';
          // Description: Location to indicate where the change occurred
          let line = '';
          // Description: Line holder for event-specific message
          if (name === 'deleted') {
            line = `${make} peripheral deleted with MAC address ${mac} at Location ${loc}.`;
            // Description: Build message for deletion events
          } else if (name === 'updated') {
            line = `${make} peripheral updated with MAC address ${mac} at Location ${loc}.`;
            // Description: Build message for update events
          } else {
            line = `${make} peripheral added with MAC address ${mac} at Location ${loc}.`;
            // Description: Build message for installed/installing events
          }
          lines.push(line);
          // Description: Accumulate each peripheral line for final copy output
        }
      }
      cellValue = [valueText, ...lines].join('\n');
      // Description: Combine base details with peripheral lines separated by newlines for clipboard
      // issue#2398 end
    } else if (event.colDef.valueGetter) {
      cellValue = event.colDef.valueGetter({ data: event.data });
    } else {
      cellValue = this.getNestedProperty(event.data, columnField);
    }

    // Set context menu visibility and position
    this.contextMenu = {
      visible: true,
      x: event.event.clientX,
      y: event.event.clientY,
      value: cellValue || 'N/A',
    };
  }


  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied to clipboard:', value);
      this.contextMenu.visible = false;  // Hide context menu after copying
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }


  // Hide context menu on outside click
  @HostListener('document:click')
  onDocumentClick(): void {
    this.contextMenu.visible = false;
  }
  preventDefaultContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }
  /* End Copy Data cell Value function   */

   onGridReady(params: GridReadyEvent) {
      this.deviceId = localStorage.getItem('deviceId');
      this.mergeDeviceAndPeripheralIds(
        this.peripheralService.peripheralIds.getValue(),
        this.deviceId
      );

      this.gridApi = params.api;
      params.api.setGridOption('datasource', this.dataSource);
    }

    selectEventType(data: any) {
      const value = data.target.value;
      if (value === 'All') {
        this.deviceHistoryPayload.filters = [
          this.deviceHistoryPayload.filters[0],
          {
            field: 'eventType.id',
            operator: 'ne',
            value: '11',
          },
          {
            field: 'eventType.id',
            operator: 'ne',
            value: '12',
          },
        ];
      } else {
        this.deviceHistoryPayload.filters = [
          this.deviceHistoryPayload.filters[0],
          {
            field: 'eventType.Id',
            operator: 'eq',
            value,
          },
        ];
      }
      this.refreshGrid();
    }

    private syncEntityIdFilter(): void {
      this.deviceHistoryPayload.filters[0] = {
        field: 'entityId',
        operator: 'in',
        value: this.deviceAndPeriIds.length
          ? this.deviceAndPeriIds
          : this.deviceId
            ? [Number(this.deviceId)]
            : [],
      };
    }

    /** Keep gateway device id in the audit filter when peripherals reload. */
    private mergeDeviceAndPeripheralIds(
      peripheralIds: number[] | null | undefined,
      deviceId: string | null
    ): void {
      const merged = new Set<number>(this.deviceAndPeriIds);
      (peripheralIds ?? []).forEach((id) => merged.add(id));
      if (deviceId != null && deviceId !== '') {
        merged.add(Number(deviceId));
      }
      this.deviceAndPeriIds = Array.from(merged);
    }

    private refreshGrid(): void {
      if (!this.gridApi) {
        return;
      }
      this.deviceHistoryPayload.page = 0;
      this.gridApi.paginationGoToFirstPage();
      this.gridApi.purgeInfiniteCache();
    }

    private syncGridHostHeight(rows: Array<{ details?: string }>): void {
      // Dynamic content height from actual current-page row heights (not a fixed px).
      const rowHeights = rows.map((row) =>
        resolveCommentAuditRowHeightPx(row?.details)
      );
      const bodyPx =
        rowHeights.length > 0
          ? rowHeights.reduce((sum, height) => sum + height, 0)
          : AG_GRID_EMPTY_BODY_ROW_PX;
      const contentPx = AG_GRID_HEADER_AND_PAGING_PX + bodyPx;
      // Reserve ~25% of calculated height for surrounding page/UI chrome.
      const minHostPx = AG_GRID_HEADER_AND_PAGING_PX + AG_GRID_EMPTY_BODY_ROW_PX;
      this.gridHostHeightPx = Math.max(minHostPx, Math.round(contentPx * 0.84));
    }
}
